import Link from "next/link";
import { StaticImageData } from "next/image";
import AmdLogo from "public/pricing/amd-w-logo.png";
import { scrollToElement } from "@/utils/scrollToElement";

type ISVData = {
  sku: string;
  image: StaticImageData;
  processor: string;
  memory: string;
  basecock_boost: string;
  disk: string;
  gpu: string;
  price: string;
};

export const ISV_DESKTOP_DATA: ISVData[] = [
  {
    sku: "A-ISVD1",
    image: AmdLogo,
    processor: "AMD RYZEN 3900X",
    memory: "64GB",
    basecock_boost: "3.8 GHZ | 4.6 GHZ",
    disk: "2 X 2TB",
    gpu: "NVIDIA RTX 2080Ti",
    price: "$420",
  },
  {
    sku: "A-ISVD2",
    image: AmdLogo,
    processor: "AMD RYZEN 5900X",
    memory: "64GB",
    basecock_boost: "3.7 GHZ | 4.8 GHZ",
    disk: "2 X 2TB",
    gpu: "RTX 4080",
    price: "$546",
  },
  {
    sku: "A-ISVD3",
    image: AmdLogo,
    processor: "AMD Ryzen™ 9 7950X3D",
    memory: "128GB",
    basecock_boost: "4.2 GHZ | 5.7 GHZ",
    disk: "2 X 4TB",
    gpu: "NVIDIA T1000-8GB",
    price: "$570",
  },
  {
    sku: "A-ISVD4",
    image: AmdLogo,
    processor: "AMD TR PRO 7965WX 24C",
    memory: "128GB",
    basecock_boost: "4.2 GHZ | 5.3 GHZ",
    disk: "2 X 256GB | 2 X 4TB",
    gpu: "1 X NVIDIA RTX™ A4000 16GB GDDR6",
    price: "$810",
  },
  {
    sku: "A-ISVD5",
    image: AmdLogo,
    processor: "AMD TR PRO 7965WX 24C",
    memory: "256GB",
    basecock_boost: "4.2 GHZ | 5.3 GHZ",
    disk: "2 X 256GB | 2 X 4TB",
    gpu: "2 X NVIDIA RTX™ A4000 16GB GDDR6",
    price: "$1,170",
  },
  {
    sku: "A-ISVD6",
    image: AmdLogo,
    processor: "AMD TR PRO 7975WX 32C",
    memory: "128GB",
    basecock_boost: "4 GHZ | 5.3 GHZ",
    disk: "2 X 512GB | 2 X 4TB",
    gpu: "1 X NVIDIA RTX™ A4000 16GB GDDR6",
    price: "$1,050",
  },
  {
    sku: "A-ISVD7",
    image: AmdLogo,
    processor: "AMD TR PRO 7975WX 32C",
    memory: "256GB",
    basecock_boost: "4 GHZ | 5.3 GHZ",
    disk: "2 X 512GB | 2 X 4TB",
    gpu: "2 X NVIDIA RTX™ A4000 16GB GDDR6",
    price: "$1,290",
  },
  {
    sku: "A-ISVD8",
    image: AmdLogo,
    processor: "AMD TR PRO 7985WX 64C",
    memory: "512GB",
    basecock_boost: "3.2 GHZ | 5.1 GHZ",
    disk: "2 X 1TB | 4 X 4TB",
    gpu: "1 X NVIDIA RTX™ A5000 32GB GDDR6",
    price: "$2,280",
  },
  {
    sku: "A-ISVD9",
    image: AmdLogo,
    processor: "AMD TR PRO 7985WX 64C",
    memory: "512GB",
    basecock_boost: "3.2 GHZ | 5.1 GHZ",
    disk: "2 X 1TB | 4 X 4TB",
    gpu: "2 X NVIDIA RTX™ A5000 32GB GDDR6",
    price: "$2,640",
  },
  {
    sku: "A-ISVD10",
    image: AmdLogo,
    processor: "AMD TR PRO 7995WX 96C",
    memory: "1024GB",
    basecock_boost: "2.5 GHZ | 5.1 GHZ",
    disk: "2 X 1TB | 4 X 4TB",
    gpu: "1 X NVIDIA RTX™ A6000 48GB GDDR6",
    price: "$3,600",
  },
  {
    sku: "A-ISVD11",
    image: AmdLogo,
    processor: "AMD TR PRO 7995WX 96C",
    memory: "1024GB",
    basecock_boost: "2.5 GHZ | 5.1 GHZ",
    disk: "2 X 1TB | 4 X 4TB",
    gpu: "2 X NVIDIA RTX™ A6000 48GB GDDR6",
    price: "$4,200",
  },
];

export const FOOTER_NOTE =
  "(The above pricing given is for Linux . Windows Licensing needs to be purchased Seperately) ";

export const FOOTER_CONSTANTS = {
  text1: (
    <>
      We offer a range of ISV desktops tailored for your business needs. Pricing may
      fluctuate based on configuration, duration, and region. For more details, please
      contact{" "}
      <Link
        href="#contact-us"
        onClick={(e) => {
          e.preventDefault();
          scrollToElement("contact-us", 120);
        }}
        target="_blank"
        style={{ textDecoration: "underline", color: "#1E87F0", fontWeight: 700 }}
      >
        our sales team.
      </Link>{" "}
    </>
  ),
};
